import apiService from "./apiService";
import AppConstants from "../appConstants";

class LayoutService {
    checkSavedNews(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LAYOUT_CHECK_SAVED_NEWS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAllLayout(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LAYOUT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getLayoutDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_LAYOUT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerLayout(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_LAYOUT_UPDATE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteLayout(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_LAYOUT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_LAYOUT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================

    getAllLayoutWdmaHist(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LAYOUT_WDMA_HIST_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getLayoutWdmaHistDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_LAYOUT_WDMA_HIST}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    deleteLayoutWdmaHist(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_LAYOUT_WDMA_HIST}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
}

export default new LayoutService();
